var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ko/phone_number/index.js
 ** module id = 825
 ** module chunks = 0
 **/